// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageViewer_wrapper__yqzOy","image":"ImageViewer_image__uP7ST"};